import { render, staticRenderFns } from "./VotingInfo.vue?vue&type=template&id=41a69157"
import script from "./VotingInfo.vue?vue&type=script&lang=ts"
export * from "./VotingInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports